import './StartClient.scss'
import * as Common from '@tfo/common'
import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import { Elements, Grid, TextButton } from '@tfo/common'
import RootStore from '../../../../stores/RootStore'
import { useHistory } from 'react-router-dom'
const { Heading3, Heading1, Paragraph } = Elements
import { Tooltip, Grid as MuiGrid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import MissingInvoiceAddress from '../missing-invoice-address/MissingInvoiceAddress'
import { showTemporaryMessageStartPage } from '../../../../utils/Utils'
import TechnicalIssuesMessage from '../../../../components/technical-issues-message/TechnicalIssuesMessage'

export interface StartClientProps {
	rootStore?: RootStore
}

const HtmlTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: '#FFFFFF',
		color: '#3D3D3C',
		maxWidth: 220,
		fontSize: theme.typography.pxToRem(12),
		border: '1px solid #dadde9',
		display: 'flex'
	},
}))(Tooltip);

const StartClient = (props: StartClientProps & WrappedComponentProps) => {
	const history = useHistory()
	const store = props.rootStore!.clientViewStore!
	const { intl } = props
	const storeHook = Common.hooks.useStore()
	const [reportsNotifications, setReportsNotifications] = React.useState(0)
	const hasInvoiceAddress = store.company?.costCenters.length > 0


	React.useEffect(() => {
		setReportStore()
	}, [])

	React.useEffect(() => {
		setReportsNotifications(calculateReportsNotification())
	}, [store.reportsStore, store.reportsStore?.initialDataLoaded])

	const setReportStore = async () => {
		await store.setReportStore()
	}

	const onGoToReports = async () => {
		history.push('/reports')
	}

	const onGoToArchive = async () => {
		history.push('/archive')
	}

	const calculateReportsNotification = () => {
		return store.reportsStore?.numberOfWaitingApproval + store.reportsStore?.numberOfOngoing + store.reportsStore?.amountNotReadReports
	}

	return (
		<>
			{!hasInvoiceAddress ?
				<MissingInvoiceAddress />
				:
				<>
					<Grid.GridWrapper className="StartClient" style={{ maxWidth: "90%", marginTop: '10vh', marginBottom: '10vh' }}>
						<Grid.GridContainer>
							{!showTemporaryMessageStartPage() &&
								<div>
									<Heading1 style={{ textAlign: 'center', marginBottom: '70px', fontSize: '5.2rem', lineHeight: 1 }}>
										{intl.formatMessage({ id: 'client.start.welcome' })} {storeHook.userStore.firstName.trim()}!
									</Heading1>
								</div>
							}
							<TechnicalIssuesMessage />
							{showTemporaryMessageStartPage() &&
								<>
									<div style={{ textAlign: 'center', marginBottom: '20px', fontSize: '1.6rem' }}>
										{intl.formatMessage({ id: 'client.start.summerdelays.row1' })}
									</div>
									<div style={{ textAlign: 'center', marginBottom: '20px', fontSize: '1.6rem' }}>
										{intl.formatMessage({ id: 'client.start.summerdelays.row2' })}
									</div>
									<div style={{ textAlign: 'center', marginBottom: '50px', fontSize: '1.6rem' }}>
										{intl.formatMessage({ id: 'client.start.summerdelays.row3' })}
									</div>
								</>
							}
						</Grid.GridContainer>
						<Grid.GridWrapper style={{ maxWidth: '90%' }}>
							<button
								className={'Select Select__NewReport'}
								style={{ marginLeft: '0' }}
								onClick={() => history.push(store.company.subsidiaries?.length > 0 ? '/sub-companies' : `/service-packages/${store.company.id}`)}>
								<div className={'Select__InnerGridWrapper'}>
									<div className={'Select__InnerGrid'}>
										<div className={'Select__InnerContent'}>
											<div className={'Select__Icon'}>
												<div className={'Select__IconNewReport'} />
											</div>
											<Heading3>
												{intl.formatMessage({ id: 'client.start.newReport.heading' })}
											</Heading3>
											<Paragraph>
												{intl.formatMessage({ id: 'client.start.newReport.body' })}
											</Paragraph>
										</div>
									</div>
								</div>
							</button>
							<div className={'StartClient__Divider'}></div>
							<button
								className={'Select Select__Reports'}
								style={{ marginLeft: '0' }}
								onClick={() => onGoToReports()}>
								<div className={'Select__InnerGridWrapper'}>
									<div className={'Select__InnerGrid'}>
										<div className={'Select__InnerContent'}>
											<HtmlTooltip
												placement="top-start"
												title={
													<>
														<MuiGrid container justifyContent='space-between'>
															<MuiGrid item xs={9}>
																<div style={{ fontSize: '1.2rem', padding: '5px' }}>{intl.formatMessage({ id: 'client.reports.filter.waiting.clean' })}</div>
															</MuiGrid>
															<MuiGrid item xs={3}>
																<div style={{ fontSize: '1.2rem', padding: '5px' }}>{store.reportsStore?.numberOfWaitingApproval}</div>
															</MuiGrid>
															<MuiGrid item xs={9}>
																<div style={{ fontSize: '1.2rem', padding: '5px' }}>{intl.formatMessage({ id: 'client.reports.filter.ongoing.clean' })}</div>
															</MuiGrid>
															<MuiGrid item xs={3}>
																<div style={{ fontSize: '1.2rem', padding: '5px' }}>{store.reportsStore?.numberOfOngoing}</div>
															</MuiGrid>
															<MuiGrid item xs={9}>
																<div style={{ fontSize: '1.2rem', padding: '5px' }}>{intl.formatMessage({ id: 'client.reports.filter.unread.clean' })}</div>
															</MuiGrid>
															<MuiGrid item xs={3}>
																<div style={{ fontSize: '1.2rem', padding: '5px' }}>{store.reportsStore?.amountNotReadReports}</div>
															</MuiGrid>
														</MuiGrid>
													</>
												}>
												<div className='Select__tooltipContent'>{reportsNotifications}</div>
											</HtmlTooltip>
											<div className={'Select__Icon'}>
												<div className={'Select__IconReports'} />
											</div>
											<Heading3>
												{intl.formatMessage({ id: 'client.start.reports.heading' })}
											</Heading3>
											<Paragraph>
												{intl.formatMessage({ id: 'client.start.reports.body' })}
											</Paragraph>
										</div>
									</div>
								</div>
							</button>
							<div className={'StartClient__Divider'}></div>
							<button
								className={'Select Select__Archive'}
								style={{ marginLeft: '0' }}
								onClick={() => onGoToArchive()}>
								<div className={'Select__InnerGridWrapper'}>
									<div className={'Select__InnerGrid'}>
										<div className={'Select__InnerContent'}>
											<div className={'Select__Icon'}>
												<div className={'Select__IconArchive'} />
											</div>
											<Heading3>
												{intl.formatMessage({ id: 'client.start.archive.heading' })}
											</Heading3>
											<Paragraph>
												{intl.formatMessage({ id: 'client.start.archive.body' })}
											</Paragraph>

										</div>
									</div>
								</div>
							</button>
						</Grid.GridWrapper>
					</Grid.GridWrapper>
				</>
			}
		</>
	)
}

export default inject('rootStore')(injectIntl(observer(StartClient)))
